import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { FolderLabel } from "../FolderLabel";
import { PlanNameList } from "../PlanNameList";
import { ValueName } from "../../ValueName";
import { UNASSIGNED_AXIS_KEY } from "../constants";
import type { FoldersPerColumnProps } from "./types";

export const FoldersPerColumn = ({
  table,
  planNameById,
}: FoldersPerColumnProps) => {
  const { t } = useTranslation();

  const { rows, columns, floorPlanIdsByCell, planCountByColumn } = table;
  const notAssignedLabel = t("smartSurveyor.folders.suggestion.notAssigned");
  const lastRowIndex = rows.values.length - 1;

  return (
    <>
      <div className="sticky top-0 z-10 col-span-full grid grid-cols-subgrid bg-white">
        {rows.key !== null && (
          <span className="flex items-start py-3.5 border-b border-gray-200 px-3 text-xs font-medium uppercase leading-5 tracking-wide text-gray-500">
            {t("smartSurveyor.folders.suggestion.level")}
          </span>
        )}
        {columns.values.map((columnValue, columnIndex) =>
          columnValue === null ? (
            <span
              key={UNASSIGNED_AXIS_KEY}
              className="flex items-start py-3.5 border-b border-gray-200 px-3 text-sm font-semibold text-gray-700"
            >
              {notAssignedLabel}
            </span>
          ) : (
            <span
              key={columnValue.code}
              className="flex items-start py-3.5 rounded-t-lg border border-blue-300 border-b-blue-200 bg-blue-100 px-3 text-sm font-semibold text-blue-700"
            >
              <FolderLabel
                name={columnValue.name}
                fileCode={columnValue.fileCode}
                planCount={planCountByColumn[columnIndex]}
                iconSize={16}
              />
            </span>
          ),
        )}
      </div>
      {rows.values.map((rowValue, rowIndex) => (
        <div
          key={rowValue?.code ?? UNASSIGNED_AXIS_KEY}
          className="col-span-full grid grid-cols-subgrid"
        >
          {rows.key !== null && (
            <span className="flex min-h-11 items-center border-b border-gray-100 px-3 text-sm font-medium text-gray-700">
              <ValueName
                name={rowValue?.name ?? notAssignedLabel}
                fileCode={rowValue?.fileCode ?? null}
              />
            </span>
          )}
          {columns.values.map((columnValue, columnIndex) => (
            <div
              key={columnValue?.code ?? UNASSIGNED_AXIS_KEY}
              className={clsx(
                "flex min-h-11 items-center px-3 py-2",
                columnValue === null
                  ? "border-b border-gray-100"
                  : "border-x border-b border-blue-300 bg-blue-50",
                columnValue !== null &&
                  (rowIndex === lastRowIndex
                    ? "rounded-b-lg"
                    : "border-b-blue-100"),
              )}
            >
              <PlanNameList
                floorPlanIds={floorPlanIdsByCell[rowIndex][columnIndex]}
                planNameById={planNameById}
              />
            </div>
          ))}
        </div>
      ))}
    </>
  );
};
